import axios from 'axios';
import { getApiHeader } from '../services/getApiHeaders';

/**
 * Get OAuth redirect url
 * @param {*} payload 
 * @returns 
 */
export function getOAuthRedirectUrl(payload){
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/oauth/redirecturl?channelId=' +  payload.channel_id,
        withCredentials: true,
        headers: getApiHeader(),
    }

    return axios(options)
}

/**
 * Verify callback information
 * @param {*} payload 
 * @returns 
 */
export function verifyOAuthCallback(payload){
    let data = {
        ChannelId: payload.channel_id,
        SellingPartnerId: (' ' + payload.selling_partner_id).trim(),
        MwsAuthToken: (' ' + payload.mws_auth_token).trim(),
        State: (' ' + payload.state).trim(),
        SpApiOauthCode: (' ' + payload.spapi_oauth_code).trim()
    };

    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/oauth/callback',
        withCredentials: true,
        headers: getApiHeader(),
        data,
    }

    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/settingOAuth.js